import { useQuery } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

export type TrackingAddPrintData = {
    idx: string;
    a_company: string;
    f_company: string;
    t_company: string;
};

type GetTrackingAddPrintResponse = {
    statusCode: number;
    message: string;
    data: TrackingAddPrintData;
};

export const useGetTrackingAddPrint = (idx: string) => {
    return useQuery<TrackingAddPrintData>({
        queryKey: ["useGetTrackingAddPrint", idx],
        queryFn: async () => {
            const { data } = await axiosInstance.get<GetTrackingAddPrintResponse>(`${enum_api_uri.tracking_add_print}?idx=${idx}`);
            return data.data;
        },
        enabled: !!idx,
    });
};
